import {
    GET_ALL_PLANS_BEGIN, GET_ALL_PLANS_SUCCESS, GET_ALL_PLANS_FAILURE,
    GET_PLAN_BEGIN, GET_PLAN_SUCCESS, GET_PLAN_FAILURE,
    POST_PLAN_BEGIN, POST_PLAN_SUCCESS, POST_PLAN_FAILURE,
    PUT_PLAN_BEGIN, PUT_PLAN_SUCCESS, PUT_PLAN_FAILURE,
    DELETE_PLAN_BEGIN, DELETE_PLAN_SUCCESS, DELETE_PLAN_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // Get All Plans
    allPlans: null,
    isLoadingAllPlans: false,
    hasErrorAllPlans: null,

    // Get Plan
    selectedPlan: null,
    isLoadingSelectedPlan: false,
    hasErrorSelectedPlan: null,

    // Post Plan
    createdPlan: null,
    isCreatingPlan: false,
    hasErrorCreatedPlan: null,

    // Put Plan
    updatedPlan: null,
    isUpdatingPlan: false,
    hasErrorUpdatedPlan: null,

    // Delete Plan
    deletedPlan: null,
    isDeletingPlan: false,
    hasErrorDeletedPlan: null
}

/**
 * @description Reducer function for managing the state of plans.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the plans.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state of the plans.
 */
const ReducerPlan = (state = initialState, action) => {
    switch (action.type) {

    // Get All Plans
    case GET_ALL_PLANS_BEGIN: {
        return {
            ...state,
            isLoadingAllPlans: true
        }
    }
    case GET_ALL_PLANS_SUCCESS: {
        return {
            ...state,
            allPlans: action.payload,
            isLoadingAllPlans: false,
            hasErrorAllPlans: null
        }
    }
    case GET_ALL_PLANS_FAILURE: {
        return {
            ...state,
            allPlans: null,
            isLoadingAllPlans: false,
            hasErrorAllPlans: action.payload
        }
    }

    // Get Plan
    case GET_PLAN_BEGIN: {
        return {
            ...state,
            isLoadingSelectedPlan: true
        }
    }
    case GET_PLAN_SUCCESS: {
        return {
            ...state,
            selectedPlan: action.payload,
            isLoadingSelectedPlan: false,
            hasErrorSelectedPlan: null
        }
    }
    case GET_PLAN_FAILURE: {
        return {
            ...state,
            selectedPlan: null,
            isLoadingSelectedPlan: false,
            hasErrorSelectedPlan: action.payload
        }
    }

    // Post Plan
    case POST_PLAN_BEGIN: {
        return {
            ...state,
            isCreatingPlan: true
        }
    }
    case POST_PLAN_SUCCESS: {
        return {
            ...state,
            createdPlan: action.payload,
            isCreatingPlan: false,
            hasErrorCreatedPlan: null
        }
    }
    case POST_PLAN_FAILURE: {
        return {
            ...state,
            createdPlan: null,
            isCreatingPlan: false,
            hasErrorCreatedPlan: action.payload
        }
    }

    // Put Plan
    case PUT_PLAN_BEGIN: {
        return {
            ...state,
            isUpdatingPlan: true
        }
    }
    case PUT_PLAN_SUCCESS: {
        return {
            ...state,
            updatedPlan: action.payload,
            isUpdatingPlan: false,
            hasErrorUpdatedPlan: null
        }
    }
    case PUT_PLAN_FAILURE: {
        return {
            ...state,
            updatedPlan: null,
            isUpdatingPlan: false,
            hasErrorUpdatedPlan: action.payload
        }
    }

    // Delete Plan
    case DELETE_PLAN_BEGIN: {
        return {
            ...state,
            isDeletingPlan: true
        }
    }
    case DELETE_PLAN_SUCCESS: {
        return {
            ...state,
            deletedPlan: action.payload,
            isDeletingPlan: false,
            hasErrorDeletedPlan: null
        }
    }
    case DELETE_PLAN_FAILURE: {
        return {
            ...state,
            deletedPlan: null,
            isDeletingPlan: false,
            hasErrorDeletedPlan: action.payload
        }
    }

    default: return state

    }
}

export default ReducerPlan